import React from 'react';

interface ExternalLinkIconProps {
    className?: string;
}

const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = ({ className }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M6.66667 4H4C3.26362 4 2.66667 4.59695 2.66667 5.33333V12C2.66667 12.7364 3.26362 13.3333 4 13.3333H10.6667C11.403 13.3333 12 12.7364 12 12V9.33333M9.33333 2.66667H13.3333M13.3333 2.66667V6.66667M13.3333 2.66667L6.66667 9.33333"
            stroke="#0E62F4"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ExternalLinkIcon;

